import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'
import { ResetPasswordAuthUserCommandRequest } from 'domain/entities/authUser'

export const resetPasswordRepresentativeCommand = (
  repository: IRepresentativeRepository,
  data: ResetPasswordAuthUserCommandRequest,
) => {
  return repository.resetPassword(data)
}
